import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salveazaTargetareExcludere } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useSalveazaTargetareExcludere() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: salveazaTargetareExcludere,
    onSuccess: (_, variabile) => {
      if (variabile.cui) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.targetare.firma(variabile.cui),
        });
      }
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.contacteStats(),
      });
    },
  });
}
